import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { FaPlusCircle } from 'react-icons/fa';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import ReceiptDocs from './ReceiptDocs';
// import Voucher from 'src/models/AP/VoucherMaintenanceForm';
import { ExpenseType } from 'src/models/AP/ExpenseType';
// import Expense from 'src/models/AP/Expense';
import CreditCardRecForm from 'src/models/AP/CreditCardRecForm';
import moment from 'moment';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';
import Personnel from 'src/models/personnel/Personnel';
import FindPersonDialog from '../dialogs/FindPersonDialog';
import DefineBudgetCategoryDialog from '../dialogs/DefineBudgetCategoryDialog';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import WarningDialog from '../dialogs/WarningDialog';
// icons
import { BiReceipt, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaLock, FaPrint, FaRegSave } from 'react-icons/fa';
import { BsLightningFill } from 'react-icons/bs';
// import { FaRegFileExcel } from 'react-icons/fa';
import { GiQuillInk } from 'react-icons/gi';
import { IoMdExit } from 'react-icons/io';
import { FaMoneyCheckAlt, FaCreditCard } from 'react-icons/fa';
// import { MdDoNotDisturb } from 'react-icons/md';
import { VscGraph } from 'react-icons/vsc';
import ReportOptionsDialog from '../dialogs/ReportOptionsDialog';
import ChooseVouchersDialog from '../dialogs/ChooseVouchersDialog';
import CreditCardTransaction from 'src/models/AP/CreditCardTransaction';
import CreditCardTransactionDetail from 'src/models/AP/CreditCardTransactionDetail';
import AccountInfo from 'src/models/AP/AccountInfo';
import CreditCardType from 'src/models/AP/CreditCardType';
// import { SelectItem } from 'src/models/common/SelectItem';
import VoucherReceipt from 'src/models/AP/VoucherReceipts';
import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
import Account from 'src/models/Account';
import TSDIEmployeesDialog from '../dialogs/TSDIEmployeesDialog';
import Employee from 'src/models/AP/Employee';
import CreditCardStatementDialog from '../dialogs/CreditCardStatementDialog';
import LoadRawDataFileDialog from '../dialogs/LoadRawDataFileDialog';
import EnterCheckNumberDialog from '../dialogs/EnterCheckNumberDialog';
import CreateCheckWarningDialog from '../dialogs/CreateCheckWarningDialog';
import OutputDestinationDialog from '../dialogs/OutputDestinationDialog';
import APNavBar from '../APNavBar';

const CreditCardsRecPage = () => {
    const dispatch = useDispatch();
    const { get, post, del, put, response } = useFetch();
    const { register, reset, handleSubmit, errors, setValue, getValues, formState } = useForm();
    const { isDirty, dirtyFields } = formState;
    // const [selectedEmployeePay, setSelectedEmployeePay] = useState(undefined);
    const [chargeIndividuals, setChargeIndividuals] = useState<Array<ChargeIndividual>>([]); // The whole personnel list
    const [allChargeIndividuals, setAllChargeIndividuals] = useState<Array<ChargeIndividual>>(undefined);
    const [expenses, setExpenses] = useState<CreditCardTransactionDetail[]>(undefined);
    const [selectedExpense, setSelectedExpense] = useState<CreditCardTransactionDetail>(undefined);
    const [selectedExpenseIndex, setSelectedExpenseIndex] = useState<number>(undefined);
    const [selectedIndividualIndex, setSelectedIndividualIndex] = useState<number>(-1);
    const [selectedCreditCardTransactionIndex, setSelectedCreditCardTransactionIndex] = useState<number>(0);
    const [creditCardTransactions, setCreditCardTransactions] = useState<Array<CreditCardTransaction>>(undefined);
    const [creditCardTypes, setCreditCardTypes] = useState<Array<CreditCardType>>([]);
    const [billingAccounts, setBillingAccounts] = useState<{ code: number, description: string}[]>([]);
    const [officeExpenseCodes, setOfficeExpenseCodes] = useState<{ code: number, description: string}[]>([]);
    // const [creditCardTypesList, setCreditCardTypesList] = useState<Array<SelectItem>>([]);
    const [creditCardTransactionDetail, setCreditCardTransactionDetail] = useState<Array<CreditCardTransactionDetail>>(undefined);
    const [loadingCreditCardTransactionDetail, setLoadingCreditCardTransactionDetail] = useState<boolean>(false);
    const [unsavedTransactionDetails, setUnsavedTransactionDetails] = useState<boolean>(false);
    const [creditCardTransactionAccountInfo, setCreditCardTransactionAccountInfo] = useState<AccountInfo>(undefined);
    const [creditCardReceipts, setCreditCardReceipts] = useState<Array<VoucherReceipt>>(undefined);
    const [fileToUpload, setFileToUpload] = useState<FormData>(undefined);
    const creditCardRecForm: CreditCardRecForm = {  
        ccId: 1, 
        ccName: 'Credit Card Name', 
        closeDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date, 
        ccTransactionNumber: 2128, 
        invoiceDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date, 
        invoiceAmount: 22.64,
        checkNumber: 3, 
        checkDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
        creditCardDetails: [
            {
                id: 1, 
                transactionItemId: 1,
                chargeDate: moment(new Date()).format('YYYY-MM-DD') as unknown as Date,
                chargeAmount: 1024.64, 
                chargedById: 1034, 
                chargedByName: 'Brendan Bryan', 
                description: 'Coffee', 
                statementDescription: 'Starbucks', 
                glAccountNumber: '2-5-07-115-0000-8',
                clientNumber: 1,
                projectNumber: 1,
                sectionNumber: 1,
                unitNumber: null,
                billingAccount: 'Lease Acqusition', 
                expenseCode: ExpenseType.Shipping_Expense, 
                budgetCategoryName: 'category', 
                budgetSubcategoryName: 'subcategory'
            },
        ], 
        chargeIndividual: [
            {
                id: 1,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 2,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
            {
                id: 3,
                personType: 'Type',
                clientNumber: 31,
                clientName: 'Client Name',
                clientCity: 'Oklahoma City',
                clientState: 'OK',
                lmNo: 72,
                firstName: 'Bob',
                lastName: 'Cratchett',
                creditCardDetailId: null,
                voucherAccountId: null
            },
        ], 
        accountInfo: {
            id: 2,
            client: 'Dudley Land Company',
            clientName: 'Dudley Land Company',
            clientNumber: 1,
            project: 'Oklahoma Office',
            projectName: 'Oklahoma Office',
            projectNumber: 1,
            prospect: null,
            sectionNumber: 3,
            sectionName: '',
            unitNumber: null,
            unitName: '',
            billingAccount: 'Lease Acquisition',
            glAccount: '2-5-07-115-0000-8',
        }
    };

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        getBillingAccounts();
        getOfficeExpenseCodes();
        getCreditCardTypes();
        getCreditCardTransactions();
        getChargeIndividuals('100'); // hard-coded for now until it is determined how to retrieve this list in this context.
        return () => {
            onDestroy();
        };
    }, []);

/*     useEffect(() => {
        if (!!creditCardTypes) {
            setCreditCardTypesList(getCreditCardTypeDropDownOptionList());
        }
    }, [creditCardTypes]); */

    useEffect(() => {
        if (!!fileToUpload) {
            prepareCsvFileForUpload(fileToUpload);
        }
    }, [fileToUpload]);

    useEffect(() => {
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > selectedCreditCardTransactionIndex) {
            getCreditCardTransactionAccountInfo(selectedCreditCardTransactionIndex);
        }
    }, [selectedCreditCardTransactionIndex]);

    useEffect(() => {
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > 0) {
            let initForm = (!!creditCardTransactions && creditCardTransactions.length > 0) ? creditCardTransactions[selectedCreditCardTransactionIndex] : new CreditCardTransaction();
            initForm.creditCardTransactionDetail = [...creditCardTransactionDetail];
            reset(initializeData(initForm));
            calculateTotal();
            setUnsavedTransactionDetails(false);
        }
    }, [creditCardTransactionDetail]);

    useEffect(() => {
        if (!!creditCardTransactions) {
            getCreditCardTypes();
            getCreditCardTransactionDetails(creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber);
            getCreditCardTransactionAccountInfo(creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber);
        }
    }, [creditCardTransactions]);

    // SelectedEmployeePay changes on Update Pay
/*     useEffect(() => {
        console.log('resetting the form');
        reset(initializeData(selectedEmployeePay));
    }, [selectedEmployeePay]); */

/*     useEffect(() => {
        console.log('Employee Pay Exceptions', creditCardRecForm);
    }, [creditCardRecForm]); */

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('CreditCardsRecPage onCreate()');
        // getPersonnelEmployeePay();
        setExpenses(creditCardRecForm?.creditCardDetails);
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('CreditCardsRecPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const defineBudgetCategory = (expense: CreditCardTransactionDetail, index: number) => {
        setSelectedExpense(expense);
        setSelectedExpenseIndex(index);
        dispatch(actions.layout.showDialog(DialogList.DEFINE_BUDGET_CATEGORY));
    };

    const getChargeIndividualsForSelectedCcTransaction = (transactionIndex: number) => {
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > transactionIndex) {
            setSelectedCreditCardTransactionIndex(transactionIndex);
            const transactionDetailId = creditCardTransactionDetail[transactionIndex].transactionItemId;
            getChargeIndividuals(transactionDetailId.toString());
            getCreditCardReceipts(transactionDetailId.toString());
        }
    };

    const getCreditCardReceipts = async (ccTransactionId: string) => {
        let result = await get(`/v1.0/AccountsPayable/receipts/creditcards/${ccTransactionId}`);

        if (response.ok) {
            setCreditCardReceipts(result?.items);
        } else {
            console.log('Unable to get credit card receipt Data!');
        }
    };

    const getCreditCardTransactions = async () => {
        let result = await get(`/v1.0/AccountsPayable/creditcards/transactions`);

        if (response.ok) {
            setCreditCardTransactions(result?.items);
        } else {
            setCreditCardTransactions([]);
            console.log('Unable to get CC transaction Data!');
        }
    };

    const getChargeIndividuals = async (ccTransactionId: string) => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals/creditcard/transaction/${ccTransactionId}`);

        if (response.ok) {
            setChargeIndividuals([]);
            setChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get charge individuals Data!');
        }
    };

    const removeChargeIndividual = async (payload: ChargeIndividual) => {
        let result = await del(`/v1.0/AccountsPayable/chargeindividual?voucherAccountId=${payload?.voucherAccountId}&ccTransactionId=${payload?.creditCardDetailId}&personType=${payload.personType}&clientNumber=${payload.clientNumber}&lmNumber=${payload.lmNo}`);

        if (response.ok) {
            getChargeIndividuals(payload.creditCardDetailId.toString());
        } else {
            console.log('Unable to delete charge individual!' + result);
        }
    };

/*     const getCreditCardTypeDropDownOptionList = () => {
        let ccTypeList: SelectItem[] =
        creditCardTypes.map(cct => {
            return { id: cct.id, name: cct.name };
            });
        return ccTypeList;
    }; */

    const handleConfirmRemovePerson = () => {
        removeSelectedPerson(selectedIndividualIndex);
    };

    const removeSelectedPerson = async (index: number) => {
        let selectedChargeIndividual = chargeIndividuals[index];
        selectedChargeIndividual.creditCardDetailId = creditCardTransactionDetail[selectedCreditCardTransactionIndex].transactionItemId;
        await removeChargeIndividual(selectedChargeIndividual);
/*         let temp = chargeIndividuals.slice();

        if (temp.length > 0 && index >= 0) {
            temp.splice(index, 1);
            setChargeIndividuals(temp);
        }

        setSelectedIndividualIndex(-1); */
    };

    const getCreditCardTypes = async () => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/creditcards/types`);

        if (response.ok) {
            setCreditCardTypes(result?.items);
        } else {
            setCreditCardTypes([]);
            console.log('Unable to get CC type Data!');
        }
    };

    const getCreditCardTransactionDetails = async (transactionId: number) => {
        setLoadingCreditCardTransactionDetail(true);
        let result = await get(`/v1.0/AccountsPayable/creditcards/transactiondetails/${transactionId}`);

        if (response.ok && result?.items?.length) {
            setCreditCardTransactionDetail([]);
            setCreditCardTransactionDetail(result?.items);
        } else {
            setCreditCardTransactionDetail([{ 
                id: 0,
                transactionItemId: 0,
                chargeDate: new Date(),
                chargeAmount: 0,
                chargedByName: '',    
                chargedById: 0,
                description: '',
                statementDescription: '',
                clientNumber: 90,
                projectNumber: 1,
                billingAccount: '1',
                expenseCode: 'O',
                glAccountNumber: '',
                sectionNumber: 0,
                unitNumber: 0,
                budgetCategoryName: '',
                budgetSubcategoryName: ''}]);
            console.log('Unable to get credit card transaction detail data!');
        }
        setLoadingCreditCardTransactionDetail(false);
    };

    const getCreditCardTransactionAccountInfo = async (transactionId: number) => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/creditcards/transaction/${transactionId}`);

        if (response.ok) {
            setCreditCardTransactionAccountInfo(result);
        } else {
            setCreditCardTransactionAccountInfo(undefined);
            console.log('Unable to get CC Acount Info Data!');
        }
    };

    const calculateTotal = () => {
        let total = 0;
        if (!!creditCardTransactionDetail && creditCardTransactionDetail.length > 0) {
            creditCardTransactionDetail?.map((ccd) =>
                total += ccd.chargeAmount
            );
        }
        return total;
    };

    const handleSelectedVouchers = (person: Personnel) => {
        console.log();
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const initializeData = (data: CreditCardTransaction) => {
        let newData: CreditCardTransaction = { ...data };

        return newData;
    };

    const addChargeIndividual = async (payload: ChargeIndividual) => {
        let result = await post(`/v1.0/AccountsPayable/chargeindividual/create`, payload);

        if (response.ok) {
            getChargeIndividuals(payload.creditCardDetailId.toString());
        } else {
            console.log('Unable to add charge individual!' + result);
        }
    };

    const addCreditCardTransactionDetail = async (payload: CreditCardTransactionDetail) => {
        let result = await post(`/v1.0/AccountsPayable/creditcard/transactiondetail/create`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        } else {
            console.log('Unable to add CC Transaction!' + result);
        }
    };

    const addCreditCardTransaction = async (payload: CreditCardTransaction) => {
        let result = await post(`/v1.0/AccountsPayable/creditcard/transaction/create`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        } else {
            console.log('Unable to add CC Transaction!' + result);
        }
    };

    const updateCreditCardRecord = async (payload: CreditCardTransaction) => {
        let result = await put(`/v1.0/AccountsPayable/creditcard/transaction`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        } else {
            console.log('Unable to update CC Transaction!' + result);
        }
    };

    const updateCreditCardTransactionDetail = async (payload: CreditCardTransactionDetail) => {
        let result = await put(`/v1.0/AccountsPayable/creditcard/transactiondetail`, payload);

        if (response.ok) {
            getCreditCardTransactions();
        } else {
            console.log('Unable to update CC Transaction detail!' + result);
        }
    };

    const handleSelectedPerson = async (person: ChargeIndividual) => {
        const transactionDetailId = creditCardTransactionDetail[selectedCreditCardTransactionIndex].transactionItemId;
        person.creditCardDetailId = transactionDetailId;
        await addChargeIndividual(person);
        /* let chargeIndividualsList: ChargeIndividual[] = [];

        let chargeIndividual: ChargeIndividual = {
            id: person.id,
            personType: person.personType,
            clientNumber: null,
            clientCity: null,
            clientState: null,
            clientName: null,
            lmNo: person.id,
            firstName: person.firstName,
            lastName: person.lastName,
            voucherAccountId: null,
            creditCardDetailId: null
        };

        chargeIndividuals?.forEach(c => {
            chargeIndividualsList?.push(c);
        });

        chargeIndividualsList?.push(chargeIndividual);

        setChargeIndividuals(chargeIndividualsList); */
    };

    const handleDownload = () => {
        console.log('Download Clicked');
    };

    const handleReport = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
    };

    const handleSelectedAccount = (account: Account) => {
        console.log(account);

        selectedExpense.glAccountNumber = account.accountNumber;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
    };

    const handleSelectedEmployee = (employee: Employee) => {
        console.log();

        selectedExpense.chargedById = employee.tsdNo;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
    };

    const handleCategories = (category: string, subcategory: string) => {
        console.log('Define Budget Category Selections: ', category, subcategory);
        selectedExpense.budgetCategoryName = category;
        selectedExpense.budgetSubcategoryName = subcategory;

        if (selectedExpenseIndex !== null) {
            creditCardRecForm.creditCardDetails[selectedExpenseIndex] = selectedExpense;
        }

        setExpenses(creditCardRecForm.creditCardDetails);
        // setSelectedExpense(modifiedExpense);
    };

    const handleConfirmCreateCheck = () => {
        console.log('Create Check confirmed');
    };

    const displayWarning = (index: number) => {
        setSelectedIndividualIndex(index);
        dispatch(actions.layout.showDialog(DialogList.WARNING));
    };

    const findTsdiEmployee = (expense: CreditCardTransactionDetail, index: number) => {
        setSelectedExpense(expense);
        setSelectedExpenseIndex(index);
        dispatch(actions.layout.showDialog(DialogList.TSDI_EMPLOYEES));
    };

    const findAvailableAccounts = (expense: CreditCardTransactionDetail, index: number) => {
        setSelectedExpense(expense);
        setSelectedExpenseIndex(index);
        dispatch(actions.layout.showDialog(DialogList.FIND_AVAILABLE_ACCOUNTS));
    };

    const accessCreditCardStatement = () => {
        dispatch(actions.layout.showDialog(DialogList.CREDIT_CARD_STATEMENT_MAINTENANCE));
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const chooseVouchers = () => {
        showDialog(DialogList.CHOOSE_VOUCHERS_TO_PAY);
    };

    const writeCheck = () => {
        showDialog(DialogList.ENTER_CHECK_NUMBER);
    };

/*     const removeSelectedPerson = (index: number) => {
        let temp = chargeIndividuals.slice();

        if (temp.length > 0 && index >= 0) {
            temp.splice(index, 1);
            setChargeIndividuals(temp);
        }

        setSelectedIndividualIndex(-1);
    }; */

    const isMainTransactionModified = () => {
        if (!!dirtyFields.creditCardType || !!dirtyFields.checkDate || !!dirtyFields.checkNumber || !! dirtyFields.closeDate ||
            !!dirtyFields.invoiceDate || !!dirtyFields.invoiceAmount) {
            return true;
        }
        return false;
    };

    const onSubmit = async (data: CreditCardRecForm) => {
        if (!!data) {
            let finalData = finalizeData(data);
            const formData = getValues();
            const transactionId = Number(formData.transactionNumber);
            if (isDirty && isMainTransactionModified()) {
                let newCreditCardTransaction = new CreditCardTransaction();
                newCreditCardTransaction.checkDate = formData.checkDate;
                newCreditCardTransaction.checkNumber = Number(formData.checkNumber);
                newCreditCardTransaction.creditCardType = formData.creditCardType;
                newCreditCardTransaction.checkDate = null;
                newCreditCardTransaction.closeDate = null;
                newCreditCardTransaction.invoiceDate = new Date();
                newCreditCardTransaction.invoiceAmount = Number(formData.invoiceAmount);

                if ((!!unsavedTransactionDetails || dirtyFields?.creditCardRecForm?.creditCardDetails?.length > 0) && !!creditCardTransactionDetail && creditCardTransactionDetail?.length > 0) {
                    newCreditCardTransaction.creditCardTransactionDetail = [...creditCardTransactionDetail];
                }

                if (isNaN(transactionId)) {
                    addCreditCardTransaction(newCreditCardTransaction);
                } else {
                    updateCreditCardRecord(newCreditCardTransaction);
                }
            } else if (!!creditCardTransactionDetail && (!!unsavedTransactionDetails || dirtyFields?.creditCardRecForm?.creditCardDetails?.length > 0)) {
                for (let ccDetailsIndex = 0; ccDetailsIndex < creditCardTransactionDetail?.length; ccDetailsIndex++) {
                    let creditCardDetailPayload = {chargeDate: creditCardTransactionDetail[ccDetailsIndex].chargeDate,
                        transactionItemId: transactionId,
                        chargeAmount: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].chargeAmount,
                        chargedById: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].chargedById,
                        chargedByName: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].chargedByName,
                        description: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].description,
                        statementDescription: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].statementDescription,
                        glAccountNumber: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].glAccountNumber,
                        clientNumber: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].clientNumber,
                        projectNumber: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].projectNumber,
                        sectionNumber: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].sectionNumber,
                        unitNumber: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].unitNumber,
                        billingAccount: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].billingAccount,
                        expenseCode: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].expenseCode,
                        id: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].id < 0 ? 0 : creditCardTransactionDetail[ccDetailsIndex].id,
                        budgetCategoryName: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].budgetCategoryName,
                        budgetSubcategoryName: formData.creditCardRecForm.creditCardDetails[ccDetailsIndex].budgetSubcategoryName
                        };
                    if (creditCardTransactionDetail[ccDetailsIndex].id < 0) {
                        addCreditCardTransactionDetail(creditCardDetailPayload);
                    } else if (!isNaN(creditCardTransactionDetail[ccDetailsIndex].id)) {
                        updateCreditCardTransactionDetail(creditCardDetailPayload);
                    }
                }
            }
            console.log(finalData);
        }
    };

    const onUpdateCCTransaction = () => {
        if (unsavedTransactionDetails) {
            updateCreditCardRecord(new CreditCardTransaction());
        }
    };

    const finalizeData = (data: CreditCardRecForm) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: CreditCardRecForm = {
            ...data,
        };

        return finalData;
    };

/*     const getPersonnelEmployeePay = async () => {
        let data = await get(`v1.0/landmen/${2}/get-personnel-employeePay`);
        if (response.ok) {
            console.log('========> Received Employee Pay Info', data);
            setSelectedEmployeePay(data);
        } else {
            // window.alert('Unable to Retrieve Selected Personnel\'s Billing Information.');
            console.log(`I don\'t think we need this.`);
        }
    }; */

    const getAllChargeIndividuals = async () => {
        let result = await get(`/v1.0/AccountsPayable/chargeindividuals`);

        if (response.ok) {
            setAllChargeIndividuals(result?.items);
        } else {
            console.log('Unable to get all charge individual Data!');
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setBillingAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const getOfficeExpenseCodes = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/expensetypes`);

        if (response.ok) {
            setOfficeExpenseCodes(result);
        } else {
            console.log('Unable to get Office Expense Code Data!!!');
        }
    };

    // const updateEmployeePay = async (data: EmployeePay) => {
    //     let result = await put(`/v1.0/landmen/${2}/save-personnel-employeePay`, data);
    //     if (response.ok) {
    //         getPersonnelEmployeePay();
    //         window.alert('Update successful');
    //     } else if (result?.messageCode === '15') {
    //         window.alert('Update failed');
    //     } else {
    //         window.alert('Update failed');
    //     }
    // };

    const displayTitle = () => {
        const title = 'Credit Card Detail';

        return title;
    };

    const displayAccountInfo = () => {
        if (!!creditCardTransactionAccountInfo) {
            return (
                <div style={{marginLeft: '7rem'}}>
                    <RHFInputBox
                        label="Client"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`client`}
                        type="text"
                        defaultVal={creditCardTransactionAccountInfo.clientName}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Prospect"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`prospect`}
                        type="text"
                        defaultVal={creditCardTransactionAccountInfo.projectName}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Section"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`section`}
                        type="text"
                        defaultVal={!!creditCardTransactionAccountInfo.sectionName ? creditCardTransactionAccountInfo.sectionName : ''}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Unit"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`unit`}
                        type="text"
                        defaultVal={!!creditCardTransactionAccountInfo.unitName ? creditCardTransactionAccountInfo.unitName : ''}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="Billing Account"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`billingAccount`}
                        type="text"
                        defaultVal={creditCardTransactionAccountInfo.billingAccount}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                    <RHFInputBox
                        label="G/L Account"
                        labelOnLeft={true}
                        labelStyle={{width: '20rem'}}
                        name={`glAccount`}
                        type="text"
                        defaultVal={creditCardTransactionAccountInfo.glAccount}
                        register={register}
                        errors={errors}
                        style={{ width: '100%', height: '2.5rem' }}
                        bodyStyle={{ width: '80%' }}
                    />
                </div>
            );
        } else {
            return (<>'No Credit Card Transaction Account Info'</>);
        }
    };

    const getNextTransactionSequenceId = () => {
        let maxId = 1;
        if (creditCardTransactionDetail?.length < 1) {
            return maxId;
        } else {
            maxId = creditCardTransactionDetail[0].id;
            for (const ccd of creditCardTransactionDetail) {
              if (ccd.id > maxId) {
                maxId = ccd.id;
              }
            }
        }
        return -(maxId + 1);
    };

    const insertBlankRow = () => {
        let newBlankRow = new CreditCardTransactionDetail();
        newBlankRow.clientNumber = (creditCardTransactionDetail?.length > 0 ? creditCardTransactionDetail[0]?.clientNumber : 90);
        newBlankRow.projectNumber = (creditCardTransactionDetail?.length > 0 ? creditCardTransactionDetail[0]?.projectNumber : 1);
        newBlankRow.billingAccount = '1';
        newBlankRow.expenseCode = 'O';
        newBlankRow.id = getNextTransactionSequenceId();
        newBlankRow.transactionItemId = 10000;

        let updatedCCTransactionList = _.cloneDeep(creditCardTransactionDetail);
        updatedCCTransactionList.push(newBlankRow);
        setCreditCardTransactionDetail(updatedCCTransactionList);
        setUnsavedTransactionDetails(true);
    };

    const displayChargeIndividuals = () => {
        if (chargeIndividuals.length) {       
            return <div>
              <table>
                  <thead>
                          <tr>
                              <th style={{ width: '20%' }}>Type</th>
                              <th style={{ width: '12%' }}>Client No.</th>
                              <th style={{ width: '28%' }}>Client/Company Name</th>
                              <th style={{ width: '10%' }}>Id No.</th>
                              <th style={{ width: '30%' }}>Name</th>
                          </tr>
                  </thead>
                  {chargeIndividuals?.map((x: ChargeIndividual, index: number) => {
                      return (
                          <tbody key={x.lmNo}>
                              <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                  <td style={{ width: '20%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].personType`}
                                          type="text"
                                          defaultVal={x.personType}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '10%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].clientNumber`}
                                          type="text"
                                          defaultVal={`${x.clientNumber}`}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '30%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].clientName`}
                                          type="text"
                                          defaultVal={x.clientName}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '10%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].lmNo`}
                                          type="text"
                                          defaultVal={x.lmNo + ''}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                  <td style={{ width: '30%' }}>
                                      <RHFInputBox
                                          name={`creditCardRecForm.chargeIndividual[${index}].firstName` + `creditCardRecForm.chargeIndividual[${index}].lastName`}
                                          type="text"
                                          defaultVal={x.firstName + ' ' + x.lastName}
                                          register={register}
                                          errors={errors}
                                          style={{ width: '100%' }}
                                          bodyStyle={{ width: '100%' }}
                                      />
                                  </td>
                                      <td style={{ width: '5%' }}>
                                          <Button 
                                              className="blue-hover-button" 
                                              reactIcon={IoMdCloseCircleOutline} 
                                              iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                              iconHoverColor="red"
                                              title="Remove Charge Individual"
                                              style={{ height: '3rem', background: 'transparent' }} 
                                              onClick={() => displayWarning(index)}
                                          />
                                      </td>
                              </tr>
                          </tbody>
                      );
                  })}
              </table>
          </div>;
          } else {
              return <div className="bold-centered">No Charge Individuals</div>;
          }
    };

    const displayCreditCardTransactions = () => {
        if (expenses?.length) {
            return <div style={{fontSize: '9px'}}>
                {!loadingCreditCardTransactionDetail &&
                 <table>
                    <thead>
                        <tr style={{height: '4rem'}}>
                            <th>Tran No.</th>
                            <th>Charge Date</th>
                            <th>Charge Amount</th>
                            <th>Charged By</th>
                            <th>Emp. Name</th>
                            <th>Description</th>
                            <th>Statement Description</th>
                            <th>G/L Account Number</th>
                            <th className="diagonal-header">Client </th>
                            <th className="diagonal-header">Project</th>
                            <th className="diagonal-header">Section</th>
                            <th className="diagonal-header">Unit</th>
                            <th>Billing Account</th>
                            <th>Expense Type</th>
                            <th>Budget Category</th>
                            <th>Budget Subcategory</th>
                        </tr>
                    </thead>
                    {!loadingCreditCardTransactionDetail && creditCardTransactionDetail?.map((x: CreditCardTransactionDetail, index: number) => {
                        return (
                            <tbody key={x.id}>
                                <tr
                                    onDoubleClick={() => insertBlankRow()}
                                    onClick={() => getChargeIndividualsForSelectedCcTransaction(index)}
                                    className="table-item-hover"
                                    style={{ textAlign: 'center' }}
                                >
                                <td style={{ width: '3%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].ccTransactionNumber`}
                                            type="number"
                                            defaultVal={x.id + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                            readOnly={true}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargeDate`}
                                            type="date"
                                            defaultVal={`${moment(x.chargeDate).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargeAmount`}
                                            type="number"
                                            defaultVal={!!x?.chargeAmount ? x.chargeAmount.toFixed(2) + '' : ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'right' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '5%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].chargedBy`}
                                            type="number"
                                            defaultVal={x.chargedById + ''}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', background: '#d5f7f5' }}
                                            bodyStyle={{ width: '100%' }}
                                            onDoubleClick={() => findTsdiEmployee(x, index)}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].employeeName`}
                                            type="text"
                                            defaultVal={x.chargedByName}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].description`}
                                            type="text"
                                            defaultVal={x.description}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].statementDescription`}
                                            type="text"
                                            defaultVal={x.statementDescription}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].glAccountNumber`}
                                            type="text"
                                            defaultVal={x.glAccountNumber}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', background: '#d5f7f5', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                            onDoubleClick={() => findAvailableAccounts(x, index)}
                                        />
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.clientNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.projectNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.sectionNumber}
                                    </td>
                                    <td style={{ width: '3%' }}>
                                        {x.unitNumber}
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].billingAccount`}
                                            defaultVal={getCodeForBillingAccount(x.billingAccount)}
                                            options={billingAccounts?.map(ba => {
                                                return { value: ba.code, label: ba.description };
                                            })}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '7%' }}>
                                        <RHFSelect
                                            name={`creditCardRecForm.creditCardDetails[${index}].expenseType`}
                                            defaultVal={getCodeForExpenseType(x.expenseCode)}
                                            options={officeExpenseCodes?.map(oec => {
                                                return { value: oec.code, label: oec.description };
                                            })}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].budgetCategoryName`}
                                            type="text"
                                            defaultVal={x.budgetCategoryName}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <RHFInputBox
                                            name={`creditCardRecForm.creditCardDetails[${index}].budgetSubcategoryName`}
                                            type="text"
                                            defaultVal={x.budgetSubcategoryName}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%', fontSize: '9px' }}
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ width: '1%', padding: '0' }}>
                                        <Button 
                                            className="blue-hover-button"
                                            reactIcon={FaPlusCircle}
                                            iconStyle={{width: '1.5rem', height: '1.5rem', marginBottom: '.5rem'}}
                                            style={{ height: '3rem', background: 'transparent' }} 
                                            onClick={() => defineBudgetCategory(x, index)}
                                            title="Add Budget Category / Subcategory"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}
                </table>}
            </div>;
        } else {
            return <div className="bold-centered">No Charge Individuals</div>;
        }
    };

    const displayTotal = () => {
        return <div className="form-row" style={{marginLeft: '5%'}}>
            <RHFInputBox
                label="Total"
                labelOnLeft={true}
                name={`total`}
                type="text"
                // defaultVal={bill.classification}
                register={register}
                errors={errors}
                style={{ width: '100%', border: '2px solid black', textAlign: 'right' }}
                bodyStyle={{ width: '18rem' }}
            />
        </div>;
    };

    const buttonClick = () => {
        console.log('Button Clicked');
    };

    const moveToLastRecord = () => {
        clearForm(false);
        let nextIndex = creditCardTransactions?.length - 1;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const moveToFirstRecord = () => {
        let nextIndex = 0;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const nextTransaction = () => {
        clearForm(false);
        let nextIndex = selectedCreditCardTransactionIndex < creditCardTransactions?.length ? selectedCreditCardTransactionIndex + 1 : selectedCreditCardTransactionIndex;
        setSelectedCreditCardTransactionIndex(nextIndex);
        getCreditCardTransactionDetails(creditCardTransactions[nextIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[nextIndex]?.transactionNumber);
    };

    const previousTransaction = () => {
        clearForm(false);
        let previousIndex = selectedCreditCardTransactionIndex < creditCardTransactions?.length ? selectedCreditCardTransactionIndex - 1 : selectedCreditCardTransactionIndex;
        setSelectedCreditCardTransactionIndex(previousIndex);
        getCreditCardTransactionDetails(creditCardTransactions[previousIndex]?.transactionNumber);
        getCreditCardTransactionAccountInfo(creditCardTransactions[previousIndex]?.transactionNumber);
    };

    const findPerson = () => {
        console.log('Add Person Button Clicked');
        showDialog(DialogList.FIND_PERSON);
    };

    const upload = async (formData: FormData) => {
        await post(
            `/v1.0/AccountsPayable/creditcard/transactions/upload`,
            formData
        );
    };

    const prepareCsvFileForUpload = (formData: FormData) => {
        upload(formData);
    };

    const getCodeForBillingAccount = (billingAccount: string) => {
        if (!!billingAccounts) {
            const billingCode = billingAccounts.find((ba) =>
                                    ba.description === billingAccount
                                )?.code;
            if (!!billingCode) {
                return billingCode;
            } else {
                return 1;
            }
        }
        return 1;
    };

/*     const getCreditCardFromId = (ccId: number) => {
        if (!!creditCardTypes) {
            const ccName = creditCardTypes.find((cct) =>
                                    cct.id === ccId
                                )?.name;
            if (!!ccName) {
                return ccName;
            } else {
                return 'Chase Southwest';
            }
        }
        return 1;
    }; */

    const getCodeForExpenseType = (expenseType: string) => {
        if (!!officeExpenseCodes) {
            const expenseCode = officeExpenseCodes.find((oec) =>
                                    oec.description === expenseType
                                )?.code;
            if (!!expenseCode) {
                return expenseCode;
            } else {
                return 'O';
            }
        }
        return 'O';
    };

    const clearForm = (resetForm: boolean) => {
        setValue(`transactionNumber`, '');
        if (resetForm) {
            reset(new CreditCardTransaction());
            setCreditCardTransactions([]);
        }
        setCreditCardTransactionDetail([]);
        setCreditCardTransactionAccountInfo(undefined);
    };

/*     const setDropdownValue = (ev: React.FormEvent<HTMLSelectElement>, currentValue: string) => {
        const previousValue = getValues('creditCardType');
        const element = document.getElementById('!creditCardType!') as HTMLSelectElement;
        if (element.value !== previousValue && element.value !== currentValue) {
            element.value = previousValue;
        }
        // ev.currentTarget.value = ev.currentTarget.value != previousValue
    }; */

    const displayLegacyCreditCardReceipts = () => {
        return <div>
            <table>
                <thead>
                    <tr style={{ textAlign: 'left' }}>
                        <th>File Name</th>
                        <th>Description</th>
                        <th>File Date</th>
                        <th>File Type</th>
                        <th>File Size</th>
                    </tr>
                </thead>
                {creditCardReceipts?.map((x: VoucherReceipt, index: number) => {
                    return (
                        <tbody key={x.id}>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '20%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileName`}
                                        type="text"
                                        defaultVal={x.fileName}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].description`}
                                        type="text"
                                        defaultVal={x.description}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileDate`}
                                        type="text"
                                        defaultVal={x.fileDate.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileType`}
                                        type="text"
                                        defaultVal={x.fileType}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`creditCardReceipts[${index}].fileSize`}
                                        type="text"
                                        defaultVal={x.fileSize.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    return (
        <div>
            <APNavBar/>
            <form id="creditCardTransaction" onSubmit={handleSubmit(onSubmit)}>
                <Page className="dlc-maxer-width">
                    <Page.Section width={8}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={displayTitle()}>
                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Query Data"
                                            reactIcon={BsLightningFill}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        />
                                        {/* <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Void an AP Voucher"
                                            reactIcon={MdDoNotDisturb}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        /> */}
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reports"
                                            reactIcon={VscGraph}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                            onClick={() => reportOptions()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Add Credit Card Transaction (Clear form)"
                                            reactIcon={BiReceipt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                            onClick={() => clearForm(true)}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Close CC Record"
                                            reactIcon={FaLock}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '1.5rem', height: '1.5rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                            onClick={() => buttonClick}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to First Record"
                                            reactIcon={BiArrowToLeft}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={moveToFirstRecord}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Previous Record"
                                            reactIcon={BiLeftArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={previousTransaction}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Save Changes"
                                            reactIcon={FaRegSave}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            type={'submit'}
                                            onClick={() => onUpdateCCTransaction()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Next Record"
                                            reactIcon={BiRightArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={nextTransaction}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Last Record"
                                            reactIcon={BiArrowToRight}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => moveToLastRecord()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Prepare Multiple Checks"
                                            reactIcon={FaMoneyCheckAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => chooseVouchers()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Write Check for CC Charges"
                                            reactIcon={GiQuillInk}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => writeCheck()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Reprint Check for Invoice"
                                            reactIcon={FaPrint}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => window.print()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Access Credit Card Statement Maintenance"
                                            reactIcon={FaCreditCard}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            onClick={() => accessCreditCardStatement()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Exit Form"
                                            reactIcon={IoMdExit}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                                            onClick={() => buttonClick}
                                        />
                                    </div>
                                    <div style={{ height: '5rem', width: '100%'}}/>
                                    <div className="form-row" style={{ marginTop: '1rem' }}>
                                        <RHFInputBox
                                            label="Credit Card Trans. No."
                                            name={`transactionNumber`}
                                            type="number"
                                            defaultVal={!!creditCardTransactions &&  creditCardTransactions?.length > 0 ? 
                                                creditCardTransactions[selectedCreditCardTransactionIndex]?.transactionNumber + '' : '0'}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                            readOnly={true}
                                        />
                                        <RHFSelect
                                            label="Credit Card"
                                            name={`creditCardType`}
                                            options={creditCardTypes?.map(c => {
                                                return { value: c.id, label: c.name };
                                                })}
                                            defaultVal={(!!creditCardTransactions && creditCardTransactions.length > 0) ?
                                                creditCardTransactions[0].creditCardType : 60}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '35%' }}
                                        />
                                        <RHFInputBox
                                            label="Check Date"
                                            name={`checkDate`}
                                            type="date"
                                            defaultVal={`${moment(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.checkDate : new Date()).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '17.5%' }}
                                            disabled={true}
                                        />
                                        <RHFInputBox
                                            label="Close Date"
                                            name={`closeDate`}
                                            type="date"
                                            defaultVal={`${moment(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.closeDate : new Date()).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '17.5%' }}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Invoice Date"
                                            name={`invoiceDate`}
                                            type="date"
                                            defaultVal={`${moment(!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.invoiceDate : new Date()).format('YYYY-MM-DD') as unknown as Date}`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                            disabled={true}
                                        />
                                        <RHFInputBox
                                            label="Invoice Amount"
                                            name={`invoiceAmount`}
                                            type="number"
                                            register={register}
                                            defaultVal={!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.invoiceAmount + '' : '0'}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '35%'}}
                                        />
                                        <RHFInputBox
                                            label="Check No."
                                            name={`checkNumber`}
                                            type="number"
                                            defaultVal={!!creditCardTransactions ? creditCardTransactions[selectedCreditCardTransactionIndex]?.checkNumber + '' : '0'}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '17.5%'}}
                                        />
                                        <div style={{ height: '5.5rem', width: '17.5%'}}/>
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={4}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="Account Information">
                                <div style={{ padding: '.5rem' }}>
                                    <div style={{ overflowY: 'scroll', height: '21.4rem' }}>
                                        {creditCardTransactionAccountInfo && displayAccountInfo()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ marginBottom: '0' }}>
                                    {loadingCreditCardTransactionDetail &&
                                        <div style={{alignContent: 'center', width: '100%'}}>
                                            <LoadingSpinner />
                                        </div>
                                    }
                                    <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                        {displayCreditCardTransactions()}
                                        <hr style={{margin: '1rem 0'}}/>
                                        {displayTotal()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={'A/P CC Receipts'}>
                                <div>
                                    <div className="tiny-panel" style={{ overflowY: 'scroll' }}>
                                        <ReceiptDocs
                                            showDialog={showDialog}
                                            hideDialog={hideDialog}
                                            hasOwnership={false}
                                            userId={2}
                                            ccTransactionId={!!creditCardTransactionDetail && selectedCreditCardTransactionIndex !== 0 ?
                                                creditCardTransactionDetail[selectedCreditCardTransactionIndex]?.id : 0}
                                        />
                                    </div>
                                    <div style={{ textAlign: 'center', overflowY: 'scroll' }}>
                                        {displayLegacyCreditCardReceipts()}
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                    <Page.Section width={6}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={'Credit Card Charge Individuals'}>
                                <div className="tiny-panel" style={{textAlign: 'center', overflowY: 'scroll'}}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ height: '3rem', justifyContent: 'center'}}
                                        text={'Add Person'}
                                        onClick={() => findPerson()}
                                    />
                                    {chargeIndividuals && displayChargeIndividuals()}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
            </form>
            <FindPersonDialog 
                dialogName={DialogList.FIND_PERSON} 
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}                
                populatePersonList={getAllChargeIndividuals}
                personList={allChargeIndividuals}
            />
            <DefineBudgetCategoryDialog 
                dialogName={DialogList.DEFINE_BUDGET_CATEGORY} 
                hideDialog={hideDialog}
                handleCategories={handleCategories}
                selectedExpense={selectedExpense}
            />
            <WarningDialog 
                dialogName={DialogList.WARNING} 
                hideDialog={hideDialog}
                handleConfirm={handleConfirmRemovePerson}
            />
            <ReportOptionsDialog 
                dialogName={DialogList.REPORT_OPTIONS} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
            <ChooseVouchersDialog 
                dialogName={DialogList.CHOOSE_VOUCHERS_TO_PAY} 
                hideDialog={hideDialog}
                handleSelectedVouchers={handleSelectedVouchers}
            />
            <FindAvailableAccountsDialog 
                dialogName={DialogList.FIND_AVAILABLE_ACCOUNTS} 
                hideDialog={hideDialog}
                handleSelectedAccount={handleSelectedAccount}
            />
            <TSDIEmployeesDialog
                dialogName={DialogList.TSDI_EMPLOYEES} 
                hideDialog={hideDialog}
                handleSelectedEmployee={handleSelectedEmployee}
            />
            <CreditCardStatementDialog 
                dialogName={DialogList.CREDIT_CARD_STATEMENT_MAINTENANCE} 
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                showDialog={showDialog}
                creditCardTypes={creditCardTypes}

            />
            <LoadRawDataFileDialog 
                dialogName={DialogList.LOAD_RAW_DATA_FILE} 
                showDialog={showDialog}
                hideDialog={hideDialog}
                setFileToUpload={setFileToUpload}
                creditCardTypes={creditCardTypes}
            />
            <EnterCheckNumberDialog 
                dialogName={DialogList.ENTER_CHECK_NUMBER} 
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
            />
            <CreateCheckWarningDialog 
                dialogName={DialogList.CREATE_CHECK_WARNING} 
                hideDialog={hideDialog}
                handleConfirm={handleConfirmCreateCheck}
                showDialog={showDialog}
            />
            <OutputDestinationDialog 
                dialogName={DialogList.OUTPUT_DESTINATION} 
                hideDialog={hideDialog}
                handleDownload={handleDownload}
            />
        </div>
    );
};

export default CreditCardsRecPage;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/CreditCardsRecPage.tsx